import type { Networkish } from "@/types";
import { isAddress, type Address } from "viem";
import useApi from "@/hooks/api/useApi";

export interface SupUnsupportedToken {
  id: number;
  chain_id: Networkish;
  address: Address;
  name: string;
  symbol: string;
  decimals: number;
  source: "uniswap" | "sec" | "manual";
  version: string; // @todo make a type for this value semver
  is_deleted: boolean;
}

/**
 * @package api:go
 * @link https://superform-xyz.postman.co/workspace/Superform~fe57d318-f198-4f97-9c50-0b2a5a78dbac/request/3472327-eb05a665-e1d9-4083-8ad5-c20d141dfd5b?ctx=documentation
 */
export default function useUnsupportedTokens() {
  const { data, isLoading, isError, error, mutate } = useApi<SupUnsupportedToken[], SupUnsupportedToken[]>(
    {
      path: `/admin/unsupported/`,
      api: "v2",
    },
    {
      strategy: "fully-cached",
      select: data => data.filter(token => !token.is_deleted && isAddress(token.address)),
    }
  );

  return {
    data,
    isLoading,
    isError,
    error,
    mutate,
  };
}
